import { useQuery } from '@tanstack/react-query';
import { z } from 'zod';
import { accountState } from '@lumlab/platform-identity/contract';
import { apiRequest } from '@lumlab/platform-product/web';

const registrationConfig = z.object({
    enabled: z.boolean(),
    termsUrl: z.url(),
    contactUrl: z.url(),
    catalog: z.array(
        z.object({
            id: z.string(),
            nameKey: z.string(),
            verticals: z.array(z.object({ id: z.string(), nameKey: z.string() })),
        }),
    ),
});
export function useRegistrationConfig() {
    return useQuery({
        queryKey: ['registration-config'],
        queryFn: async () => registrationConfig.parse(await apiRequest('/api/registration/config')),
    });
}
export function useAccountState(userId?: string) {
    return useQuery({
        queryKey: ['account-state', userId],
        enabled: !!userId,
        queryFn: async () => accountState.parse(await apiRequest('/api/account/state')),
        staleTime: 0,
    });
}
